// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-header{color:#222;background-color:transparent;font-family:Gotham;margin-left:16px;margin-right:16px}.home-header__container{padding:24px 0}.home-header__search{height:50px;background:transparent;border:1px solid #707070;border-radius:10px;outline:none}.home-header__search:focus{background-color:#fff}.home-header__subtitle{font-family:OpenSans;color:#747474}", ""]);
// Exports
module.exports = exports;
